"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Search_1 = __importDefault(require("./Search"));
const BaseSearchSchema = {
    type: 'object',
    properties: {
        sort_field: {
            type: 'object',
            required: ['field_name', 'direction'],
            properties: {
                field_name: {
                    type: 'string',
                },
                direction: {
                    type: 'string',
                    enum: ['asc', 'desc'],
                },
            },
            additionalProperties: false,
        },
    },
    additionalProperties: false,
};
const Search = (filterTypes) => {
    // Avoid mangling the base object
    const schema = JSON.parse(JSON.stringify(BaseSearchSchema));
    filterTypes.forEach((type) => {
        schema.properties[type] = Search_1.default;
    });
    return schema;
};
exports.default = Search;
